import { render, staticRenderFns } from "./SaibaMais.vue?vue&type=template&id=1ec2984c&"
import script from "./SaibaMais.vue?vue&type=script&lang=js&"
export * from "./SaibaMais.vue?vue&type=script&lang=js&"
import style0 from "./SaibaMais.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports